module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-shop-page"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('store-list')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11acb27a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/silver-shop/index.vue
// module id = 1531
// module chunks = 1